import { userConstants } from '../_constants';
import { clearSession } from '../_helpers/session';

const initialState = {
  userProfile: null,
  successRecover: false,
  successRecoverPassword: false,
  candidate_jobs: [],
  langs: [],
  schools: [],

  isLoading: false,
  isLoading2: false,

  isLoadingSchools: false,
  isLoadingLangs: false,
};

export function users(state = initialState, action) {
  switch (action.type) {
    case userConstants.IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case userConstants.IS_LOADING_CANDIDATE_SCHOOLS:
      return {
        ...state,
        isLoadingSchools: action.payload,
      };
    case userConstants.IS_LOADING_CANDIDATE_LANGS:
      return {
        ...state,
        isLoadingLangs: action.payload,
      };
    case userConstants.IS_LOADING2:
      return {
        ...state,
        isLoading2: action.payload,
      };
    case userConstants.GETALL_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GETALL_SUCCESS:
      return {
        items: action.users,
      };
    case userConstants.GETALL_FAILURE:
      return {
        error: action.error,
      };
    case userConstants.DELETE_REQUEST:
      // add 'deleting:true' property to user being deleted
      return {
        ...state,
        items: state.items.map((user) =>
          user.id === action.id ? { ...user, deleting: true } : user
        ),
      };
    case userConstants.DELETE_SUCCESS:
      // remove deleted user from state
      return {
        items: state.items.filter((user) => user.id !== action.id),
      };
    case userConstants.DELETE_FAILURE:
      // remove 'deleting:true' property and add 'deleteError:[error]' property to user
      return {
        ...state,
        items: state.items.map((user) => {
          if (user.id === action.id) {
            // make copy of user without 'deleting:true' property
            const { deleting: _deleting, ...userCopy } = user;
            // return copy of user with 'deleteError:[error]' property
            return { ...userCopy, deleteError: action.error };
          }

          return user;
        }),
      };
    case userConstants.SET_PROFILE:
      return {
        ...state,
        userProfile: action.payload,
      };
    case userConstants.SET_CANDIDATE_JOBS:
      return {
        ...state,
        candidate_jobs: action.payload,
      };
    case userConstants.SET_EXPECTED_JOBS:
      return {
        ...state,
        candidate_expected_job: action.payload,
      };
    case userConstants.SET_CANDIDATE_JOB_PROFILE:
      return {
        ...state,
        candidate_job_profile: action.payload,
      };
    case userConstants.SET_CANDIDATE_LANGUAGES:
      return {
        ...state,
        langs: action.payload,
      };
    case userConstants.SET_CANDIDATE_SCHOOLS:
      return {
        ...state,
        schools: action.payload,
      };
    case userConstants.LOGOUT:
    case 'logout':
      clearSession();
      return {
        ...initialState,
      };
    default:
      return state;
  }
}
